import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "cover-auth" }
const _hoisted_2 = { class: "widget-auth" }
const _hoisted_3 = {
  key: 0,
  class: "text-center pb-5"
}
const _hoisted_4 = {
  key: 1,
  class: "alert alert-danger mb-5"
}
const _hoisted_5 = { class: "text-sm text-center" }
const _hoisted_6 = {
  key: 2,
  class: "profile-info mb-5"
}
const _hoisted_7 = { class: "info-card" }
const _hoisted_8 = { class: "info-row" }
const _hoisted_9 = { class: "info-value" }
const _hoisted_10 = { class: "info-row" }
const _hoisted_11 = { class: "info-value" }
const _hoisted_12 = { class: "info-row" }
const _hoisted_13 = { class: "info-value" }
const _hoisted_14 = {
  key: 0,
  class: "info-row"
}
const _hoisted_15 = { class: "info-value" }
const _hoisted_16 = { class: "info-row" }
const _hoisted_17 = { class: "info-value" }
const _hoisted_18 = {
  key: 1,
  class: "info-row"
}
const _hoisted_19 = { class: "info-value" }
const _hoisted_20 = {
  key: 2,
  class: "info-row"
}
const _hoisted_21 = { class: "info-value" }
const _hoisted_22 = {
  key: 3,
  class: "info-row"
}
const _hoisted_23 = { class: "info-value" }
const _hoisted_24 = {
  key: 4,
  class: "info-row"
}
const _hoisted_25 = { class: "info-value" }
const _hoisted_26 = { class: "form-check my-5" }
const _hoisted_27 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[16] || (_cache[16] = _createElementVNode("a", { href: "#" }, [
        _createElementVNode("div", { class: "text-center mb-8" }, [
          _createElementVNode("img", {
            src: "/public/images/logo-wide.svg",
            class: "auth-logo"
          })
        ])
      ], -1)),
      _cache[17] || (_cache[17] = _createElementVNode("h2", { class: "font-semibold text-center my-6" }, "Activation de votre compte", -1)),
      (_ctx.loadingInfo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("p", { class: "text-read text-grey-600" }, "Chargement de vos informations...", -1)
          ]))]))
        : _createCommentVNode("", true),
      (_ctx.errorMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.errorMessage), 1)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.loadingInfo && _ctx.userInfo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-read text-grey-600 text-center pb-4" }, " Bienvenue sur Coop Finance ! Vérifiez vos informations ci-dessous. ", -1)),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "info-label" }, "Nom complet:", -1)),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.userInfo.prenom) + " " + _toDisplayString(_ctx.userInfo.nom), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "info-label" }, "Email:", -1)),
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.userInfo.email), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "info-label" }, "Téléphone:", -1)),
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.userInfo.telephone), 1)
              ]),
              (_ctx.userInfo.dateNaissance)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _cache[6] || (_cache[6] = _createElementVNode("span", { class: "info-label" }, "Date de naissance:", -1)),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.formatDate(_ctx.userInfo.dateNaissance)), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_16, [
                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "info-label" }, "Collectivité:", -1)),
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.userInfo.collectiviteNom), 1)
              ]),
              (_ctx.userInfo.fonction)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _cache[8] || (_cache[8] = _createElementVNode("span", { class: "info-label" }, "Fonction:", -1)),
                    _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.userInfo.fonction), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.userInfo.dateEngagement)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _cache[9] || (_cache[9] = _createElementVNode("span", { class: "info-label" }, "Date d'engagement:", -1)),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.formatDate(_ctx.userInfo.dateEngagement)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.userInfo.salaire)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _cache[10] || (_cache[10] = _createElementVNode("span", { class: "info-label" }, "Salaire brut:", -1)),
                    _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.formatMontant(_ctx.userInfo.salaire)) + " F CFA", 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.userInfo.quotiteCessiblePourcent)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _cache[11] || (_cache[11] = _createElementVNode("span", { class: "info-label" }, "Quotité cessible:", -1)),
                    _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.userInfo.quotiteCessiblePourcent) + "% (" + _toDisplayString(_ctx.formatMontant(_ctx.userInfo.quotiteCessibleMontant)) + " F CFA)", 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("form", {
              class: "form",
              onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleConfirm && _ctx.handleConfirm(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_26, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "confirmIdentity",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.identityConfirmed) = $event)),
                  class: "form-check-input"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.identityConfirmed]
                ]),
                _cache[12] || (_cache[12] = _createElementVNode("label", {
                  for: "confirmIdentity",
                  class: "form-check-label"
                }, " Je confirme que ces informations correspondent à mon identité ", -1))
              ]),
              _createElementVNode("button", {
                type: "submit",
                class: "btn lg w-100 flex-center mt-5 mb-7",
                disabled: _ctx.loading || !_ctx.identityConfirmed
              }, [
                _cache[13] || (_cache[13] = _createElementVNode("img", {
                  src: "/public/icons/icon-valider.svg",
                  class: "btn-icon",
                  alt: ""
                }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.loading ? 'Confirmation en cours...' : 'Confirmer et continuer'), 1)
              ], 8, _hoisted_27),
              _createVNode(_component_router_link, { to: "/auth/sign-in" }, {
                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                  _createElementVNode("h5", { class: "text-primary-color text-center" }, "Vous avez déjà un compte ?", -1)
                ]))]),
                _: 1
              })
            ], 32)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}